export const createTranslationsWatcher = (store) => ({
    getCurrent: () => toExposedState(store.getState().translations),
    onChange: (fn) => {
        let lastState = store.getState().translations;
        store.subscribe(() => {
            const currentState = store.getState().translations;
            if (lastState !== currentState) {
                lastState = currentState;
                fn(toExposedState(currentState));
            }
        });
    },
});
function toExposedState(translations) {
    return translations ? { type: 'READY', translations } : { type: 'NOT_READY' };
}
//# sourceMappingURL=translations-watcher.js.map